import * as store from "store";
import * as _ from "lodash";

const TOKEN = "heaps_access_token_with_roles";

interface TokenData {
  token: string;
  roles: string[];
}

export class AuthStorage {
  saveAuthData(token: TokenData): void {
    store.set(TOKEN, token);
  }

  hasToken(): boolean {
    const token: TokenData = store.get(TOKEN);

    return token && _.isObject(token);
  }

  getToken(): TokenData {
    return store.get(TOKEN);
  }

  removeToken(): void {
    store.remove(TOKEN);
  }
}
